export default "__VITE_ASSET__CYrdx_1U__"